import api from '@api/api';
import { Snippet } from '@customTypes/Entities';
import useFetchAll from '@hooks/useFetchAll';

const useSnippets = (date?: string) => {
  const { data, isFetching, error, ...rest } = useFetchAll<Snippet>({
    queryKeyRoot: 'snippets',
    apiFn: (params) => api.getSnippets(params),
    date,
  });

  return { snippets: data, isFetching, error, ...rest };
};

export default useSnippets;
